import { createSlice } from '@reduxjs/toolkit';

export type ConfirmationModalType = {
  title?: string;
  content?: React.ReactNode;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmButton?: React.ReactNode;
  cancelButton?: React.ReactNode;
  actionsDirection?: 'row' | 'column';
  type?: 'default' | 'delete';
};

export type RegularModalType = {
  id: string;
  title?: string;
  data?: unknown;
  onSubmit?: () => void;
  onCancel?: () => void;
  submitButtonText?: string;
  disabled?: boolean;
};

export type SpecificModalType = {
  modalId: string;
  data?: {
    params?: Record<string, string>;
  } | null;
};

type InitialModalType = {
  confirmation: ConfirmationModalType | null;
  regular: RegularModalType | null;
  specific: SpecificModalType;
};

const initialState: InitialModalType = {
  confirmation: null,
  regular: null,
  specific: {
    modalId: '',
    data: null,
  },
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openConfirmationModal: (state, action) => {
      state.confirmation = action.payload;
    },
    closeConfirmationModal: (state) => {
      state.confirmation = null;
    },

    openSpecificModal: (state, action) => {
      state.specific.modalId = action.payload.modalId;
      state.specific.data = action.payload.data;
    },
    closeSpecificModal: (state) => {
      state.specific.modalId = '';
      state.specific.data = null;
    },

    openRegularModal: (state, action) => {
      state.regular = action.payload;
    },
    closeRegularModal: (state) => {
      state.regular = null;
    },
  },
});

export const {
  openConfirmationModal,
  closeConfirmationModal,
  openSpecificModal,
  closeSpecificModal,
} = modalSlice.actions;

export default modalSlice.reducer;
